module.exports = __webpack_public_path__ + "static/media/detail.ae200b39.svg";